<footer class="CareTeamCardFooter">
  @if (!config.review_provider) {
    @if (pcp) {
      <div class="CareTeamCardFooter__CallText">
        <a
          class="CareTeamCardFooter__Link t-bold t-link"
          href="tel:{{ pcp.pcp_office_phone | formatCareCardPhoneNumber }}"
        >
          <icon
            name="phone"
            [config]="{ type: 'link' }"
            class="CareTeamCardFooter__Icon"
          >
          </icon>
          <span
            [innerHTML]="config.call_text || instructionalText.callPcp"
          ></span>
        </a>
      </div>
    }
    <!-- CHANGE PCP BUTTON and TEXT -->
    @if (!config.preventAddingPCP) {
      <div class="CareTeamCard__Change">
        <ds-link
          [linkConfig]="
            config | careCardLinkConfig: providerType : textToDisplay
          "
          [externalSiteModalConfig]="
            config.use_external_modal
              ? (config
                | careCardExternalLinkConfig
                  : (providerType === 'dentist'
                      ? config.dental_title
                      : config.pcp_title))
              : null
          "
          (linkClicked)="changePCPClicked.emit()"
        >
          @if (pcp?.pcp_name) {
            <span [innerHTML]="pcp | formatCareCardChangeText: config"></span>
          } @else {
            <span [innerHTML]="textToDisplay"></span>
          }
        </ds-link>
      </div>
    }
  }
</footer>
